import React from 'react';
import cx from 'classnames';
import HintTooltip from '../hint-tooltip/hint-tooltip';
import HighlightSearchMatch from '../highlight-search-match/highlight-search-match';
import { RadioSwitch, RadioWithLabelLi } from './radio-with-label.style';

const RadioWithLabel = ({
    id,
    label,
    listName,
    isDisabled = false,
    selectedValue,
    setSelectedValue,
    setSelectedDisplayName,
    searchTerm,
    hasTooltip,
    tooltipMessage,
    border = false,
}: {
    id: string;
    label: string | React.ReactNode;
    listName: string;
    isDisabled: boolean;
    selectedValue: string | undefined;
    setSelectedValue: Function;
    setSelectedDisplayName: Function;
    searchTerm?: string;
    hasTooltip?: boolean;
    tooltipMessage?: string | React.ReactNode;
    border?: boolean
}) => {
    return (
        <RadioWithLabelLi
            key={id}
            className={cx({ 'is-disabled': isDisabled })}
            border={border}
            checked={id === selectedValue}
        >
            <RadioSwitch
                type="radio"
                border={border}
                id={id}
                name={listName}
                defaultValue={id}
                checked={id === selectedValue}
                onChange={async () => {
                    setSelectedValue(id);
                    await setSelectedDisplayName(label);
                }}
            />
            {!isDisabled ? (
                <label htmlFor={id}>
                    {searchTerm ? (
                        <HighlightSearchMatch label={label} searchTerm={searchTerm} />
                    ) : (
                        label
                    )}
                </label>
            ) : (
                <span>
                    {label}
                    {hasTooltip && (
                        <HintTooltip
                            content={tooltipMessage}
                            triggerColor="grey"
                            closeBtnColor="lightGrey"
                            theme="white"
                            elName={id}
                            hasCloseBtn={false}
                            align="left"
                        />
                    )}
                </span>
            )}
        </RadioWithLabelLi>
    );
};

export default RadioWithLabel;
